module.exports = __webpack_public_path__ + "static/media/web-green-bg.58727594.svg";